import { CompanyFeaturedImageFixedTop } from "@/js/components/CompanyFeaturedImageFixedTop";

/* eslint-disable-next-line no-unused-vars */
const companyFeaturedImageFixedTop = new CompanyFeaturedImageFixedTop();
